const asyncDispatchMiddleware = (store) => (next) => (action) => {
  let actionQueue = [];

  function flushQueue() {
    actionQueue.forEach((a) => store.dispatch(a)); // Dispatch all queued actions
    actionQueue = [];
  }

  const asyncDispatch = (a) => actionQueue.push(a);

  const actionWithAsyncDispatch = {
    ...action,
    asyncDispatch,
  };

  const result = next(actionWithAsyncDispatch);
  flushQueue();

  return result;
};

export default asyncDispatchMiddleware;
